import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

import { Separator } from '../../../Layout/Landing/Content/Separator';
import { ELEMENT_DIVIDER } from './defaults';
import { DividerElementPluginOptions } from './types';

const HiddenContent = styled.div`
  display: none;
`;

const Divider = styled.div`
  margin-bottom: 32px;
  margin-top: 32px;
  user-select: none;

  ${fromScreen(451)} {
    margin-bottom: 36px;
    margin-top: 36px;
  }
`;

export const renderDividerElement =
  (_options: DividerElementPluginOptions) =>
    ({ element, children, attributes }: RenderElementProps) => {
      if (element.type === ELEMENT_DIVIDER) {
        return (
        <Divider contentEditable={false} {...attributes}>
          <Separator contentEditable={false} variant="three-dot-horizontal" />
          <HiddenContent>{children}</HiddenContent>
        </Divider>
        );
      }
      return null;
    };
